export default __webpack_public_path__ + "static/media/view-history@2x.bea9705e.png";